import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IAddToAgendaPayload } from '@app-store/slices/meetings/addToAgenda'
import { notification } from 'antd'

interface TaskAction extends Action {
    payload: IAddToAgendaPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.meetings.addToAgenda

function* addToAgendaSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.post(`/meeting/unavailable`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            if (payload?.sagaCB?.onSuccess) payload.sagaCB.onSuccess(response.result)
            notification.success({
                message: 'Session added to your agenda successfully.'
            })
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* addToAgendaSaga(): any {
    yield takeLatest<TaskAction>(onRequest, addToAgendaSagaTask)
}

export default addToAgendaSaga
